import * as THREE from 'three';
import { Weapon, WeaponConfig } from './Weapon';
import { MachineGunBullet } from '../entities/MachineGunBullet';

export class MachineGunWeapon extends Weapon {
  constructor() {
    const config: WeaponConfig = {
      name: '机枪',
      type: 'machinegun',
      damage: 8,
      cooldown: 0.1, // Very fast fire rate
      ammo: 200,
      maxAmmo: 200,
      projectileSpeed: 40,
      range: 40
    };
    super(config);
  }

  createProjectile(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy'
  ): MachineGunBullet {
    // Add spread to bullets
    const spread = 0.05;
    const spreadDirection = direction.clone();
    spreadDirection.x += (Math.random() - 0.5) * spread;
    spreadDirection.z += (Math.random() - 0.5) * spread;
    spreadDirection.normalize();

    return new MachineGunBullet(position, spreadDirection, owner, this.config.damage);
  }
}
